import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TawkService {
  private hasLoadedScript = false;
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Loads Tawk.to chat widget and sets visitor information.
   * If the script is already loaded, it will only update the visitor info.
   */
  loadTawk(name?: string | null, email?: string | null): void {
    if (!environment.production) return;

    // Check if Tawk.to script is already loaded in the DOM
    const existingTawkScript = document.querySelector('script[src*="embed.tawk.to"]');

    if (existingTawkScript || this.hasLoadedScript) {
      // Update visitor information if Tawk_API exists
      this.updateVisitorInfo(name, email);
      return;
    }

    this.hasLoadedScript = true;

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      var Tawk_API=Tawk_API||{};
      Tawk_API.visitor = {
      name : '${name ?? ''}',
      email : '${email ?? ''}'
      };

      var Tawk_LoadStart=new Date();
        (function () {
          var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/65e3375a9131ed19d973eed8/1hnvp0et6';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
        })();
      `;

    this.renderer.appendChild(document.body, script);
  }

  /**
   * Updates the visitor information for an already loaded Tawk.to widget.
   */
  updateVisitorInfo(name?: string | null, email?: string | null): void {
    if ((window as any).Tawk_API) {
      (window as any).Tawk_API.visitor = {
        name: name ?? '',
        email: email ?? ''
      };
    }
  }

  /**
   * Opens (maximizes) the Tawk.to chat widget, e.g. from a "start a chat" call to action.
   */
  maximize(): void {
    const tawkApi = (window as any).Tawk_API;
    if (tawkApi && typeof tawkApi.maximize === 'function') {
      tawkApi.maximize();
    }
  }
}
